var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fm-app" }, [
    _c("div", { staticClass: "fm-app__topbar" }),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "fm-app__container" }, [
      _c("div", { staticClass: "fm-card" }, [
        _c(
          "div",
          { staticClass: "fm-card__body" },
          [
            _c("div", { staticClass: "fm-info-banner mb-4" }, [
              _c(
                "svg",
                {
                  attrs: {
                    fill: "currentColor",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "Choose how you'd like to receive your one-time passcode (OTP)."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "FormGroup",
              { staticClass: "mb-4", attrs: { label: "Verification method" } },
              [
                _c("RadioButtonGroup", {
                  attrs: {
                    block: true,
                    options: { email: "Email", phone: "Phone" },
                    size: "sm",
                  },
                  model: {
                    value: _vm.mode,
                    callback: function ($$v) {
                      _vm.mode = $$v
                    },
                    expression: "mode",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.mode === "email"
              ? _c("EmailVerification", { on: { verified: _vm.verified } })
              : _c("PhoneVerification", { on: { verified: _vm.verified } }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "fm-app__header" }, [
      _c("div", { staticClass: "fm-app__header-text" }, [
        _c("h1", { staticClass: "fm-app__title" }, [_vm._v("Verify it's you")]),
        _vm._v(" "),
        _c("p", { staticClass: "fm-app__subtitle" }, [
          _vm._v(
            "A one-time passcode is required to continue your application."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }